import React from 'react';
import * as FiIcons from 'react-icons/fi';
import ConnectionIndicator from '../status/ConnectionIndicator';

/**
 * Agency top bar. `onSignOut` (auth-full-spec §5.1) clears the session and
 * routes to /#/login — the same contract ClientLayout's Sign out already
 * honors. Previously the agency persona had NO logout control at all, which
 * is how a stale demo session could sit in the app with no way out.
 */
function TopBar({ title, queueCount, onMenu, onSignOut }) {
  return (
    <header className="topbar">
      <div>
        <button className="menu-button" onClick={onMenu} type="button">
          <FiIcons.FiMenu />
        </button>
        <span className="breadcrumb">Agency /</span>
        <strong>{title}</strong>
      </div>
      <div className="topbar-actions">
        {/* S5.3: live heartbeat indicator replaces the static "All systems
            nominal" pill; clicking it forces a manual reconnect (S7.1). */}
        <ConnectionIndicator />
        <button className="icon-button" type="button">
          <FiIcons.FiSearch />
        </button>
        <button className="icon-button notification-button" type="button">
          <FiIcons.FiBell />
          {queueCount > 0 && <span>{queueCount}</span>}
        </button>
        {onSignOut && (
          <button className="icon-button" onClick={onSignOut} title="Sign out" type="button">
            <FiIcons.FiLogOut />
          </button>
        )}
      </div>
    </header>
  );
}

export default TopBar;
